module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_05B.3f58094e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_05B.mp3
// module id = 107
// module chunks = 0